// StatsSection.js
import React from 'react';
import { motion } from 'framer-motion';

const StatsSection = () => {
  const stats = [
    {
      number: '10+',
      label: 'Years registered',
      description: 'Immigration Visa & Passport Services Limited has been on the Companies House register since November 2014'
    },
    {
      number: '2',
      label: 'Routes we cover',
      description: 'Studying overseas and working overseas, each handled from the first eligibility check to submission'
    },
    {
      number: '1:1',
      label: 'How we start',
      description: 'Every case opens with a one to one review of your background, funds and timing before anything is filed'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            A London Practice, Working<br />on Two Kinds of Move
          </h2>
          <p className="text-gray-600 font-light max-w-2xl mx-auto">
            Registered in England and Wales, and straight with you<br />about what each route involves
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="text-5xl md:text-6xl font-light text-primary mb-2">
                {stat.number}
              </div>
              <div className="text-base md:text-lg text-gray-700 font-normal mb-3">
                {stat.label}
              </div>
              <div className="text-sm text-gray-600 font-light">
                {stat.description}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
